import React from 'react';
import { FiArrowRight, FiDollarSign } from 'react-icons/fi';
import './EarnMoney.css';

const levels = [
  { level: 1, hours: 10, earning: '10%' },
  { level: 2, hours: 30, earning: '15%' },
  { level: 3, hours: 60, earning: '20%' },
  { level: 4, hours: 100, earning: '25%' },
  { level: 5, hours: 200, earning: '30%' },
  { level: 6, hours: 500, earning: '40%' },
];

const EarnMoney = () => {
  return (
    <section className="earn-section" id="earn">
      <div className="container">
        <div className="earn-grid">
          <div className="earn-content">
            <span className="section-tag earn-tag">💰 Earn Money</span>
            <h2>Get <span className="gradient-text">Paid</span> for Every Video Call You Receive</h2>
            <p className="earn-desc">
              With Slink, you earn real money every time someone video calls you. 
              At ₹15 per minute, a single 10-minute call earns you up to ₹150! 
              Level up to increase your earnings percentage.
            </p>
            <div className="earn-steps">
              <div className="earn-step">
                <div className="step-num">1</div>
                <div>
                  <strong>Download & Sign Up</strong>
                  <span>Create your profile with photos</span>
                </div>
              </div>
              <div className="earn-step">
                <div className="step-num">2</div>
                <div>
                  <strong>Receive Video Calls</strong>
                  <span>Accept calls from users who want to connect</span>
                </div>
              </div>
              <div className="earn-step">
                <div className="step-num">3</div>
                <div>
                  <strong>Earn & Withdraw</strong>
                  <span>Money goes to your wallet, withdraw anytime</span>
                </div>
              </div>
            </div>
            <a href="https://slink.astergo.in/slink-dating-app.apk" className="earn-cta">
              Start Earning Now <FiArrowRight />
            </a>
          </div>
          <div className="earn-levels">
            <h3><FiDollarSign /> Level-Based Earnings</h3>
            <p className="levels-subtitle">Complete call hours to unlock higher earning rates</p>
            <div className="levels-list">
              {levels.map((l) => (
                <div className="level-item" key={l.level}>
                  <div className="level-badge">Lvl {l.level}</div>
                  <div className="level-info">
                    <span className="level-hours">{l.hours}h required</span>
                    <div className="level-bar">
                      <div className="level-fill" style={{ width: `${(l.level / 6) * 100}%` }}></div>
                    </div>
                  </div>
                  <div className="level-earn">{l.earning}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EarnMoney;
